import { useAuth } from '../providers/AuthProvider';

// The maximum number of rows the "All" option will request. Matches the
// backend's practical cap so "All" never triggers an unbounded scan.
export const ALL_PAGE_SIZE = 1000;
export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100, ALL_PAGE_SIZE] as const;
export const DEFAULT_PAGE_SIZE = 50;

/**
 * Per-user, per-screen list page size, saved to the user's account so it's
 * sticky across sessions and devices. `listKey` identifies the screen
 * (e.g. 'users', 'devices').
 */
export function usePageSize(listKey: string): [number, (size: number) => void] {
  const { user, setListPageSize } = useAuth();
  const stored = user?.ui_preferences?.pageSizes?.[listKey];
  const pageSize = typeof stored === 'number' && stored > 0 ? stored : DEFAULT_PAGE_SIZE;
  const setPageSize = (size: number) => setListPageSize(listKey, size);
  return [pageSize, setPageSize];
}
